import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import './App.css'
import { router } from './app/router/routes'
import { AuthGate, AuthProvider } from './auth/AuthProvider'
import { ThemeWrapper } from './theme/ThemeWrapper'

function App() {
  return (
    <AuthProvider>
      <AuthGate>
        <ThemeWrapper>
          <Suspense fallback={<div className="loading-container">Loading...</div>}>
          <RouterProvider router={router} />
          </Suspense>
          </ThemeWrapper>
      </AuthGate>
    </AuthProvider>
  )
}

export default App
